<template>
  <div class="progress-ring-container">
    <svg
      class="progress-circle"
      viewBox="-50,-50,100,100"
    >
      <!-- Background track circle -->
      <circle
        v-if="showBackgroundTrack"
        :stroke="strokeColor"
        :stroke-width="strokeWidth"
        :style="{ opacity: 0.2 }"
        class="progress-circle-track"
        r="46"
      />
      <!-- Progress circle -->
      <circle
        :stroke="strokeColor"
        :stroke-width="strokeWidth"
        :style="{
          strokeDasharray: circumference,
          strokeDashoffset: strokeDashoffset,
        }"
        class="progress-circle-progress"
        r="46"
      />
    </svg>
    <div class="progress-circle-content">
      <slot />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'ProgressCircleComponent',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 1,
    },
    strokeWidth: {
      type: Number,
      default: 8,
    },
    strokeColor: {
      type: String,
      default: '#fff',
    },
    showBackgroundTrack: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const circumference = computed(() => 2 * Math.PI * 46);

    const progress = computed(() => {
      const value = Math.min(Math.max(props.value, props.min), props.max);
      return (value - props.min) / (props.max - props.min);
    });

    const strokeDashoffset = computed(() => circumference.value * (1 - progress.value));

    return {
      circumference,
      strokeDashoffset,
    };
  },
});
</script>

<style lang="scss" scoped>
.progress-circle-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.progress-circle {
  position: absolute;
  top: -1px;
  left: -1px;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
}

.progress-circle-track,
.progress-circle-progress {
  fill: none;
  stroke-linecap: round;
  transform: rotate(-90deg);
}

.progress-circle-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
